import { StoredLink } from './type/StoredLink';

type T = (links: StoredLink) => StoredLink;

const f: T = (link) => ({ ...link, fetchCounter: link.fetchCounter + 1 });

export default f;
